import { IAlbum } from '@topshots/core-models';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'shared-components';
import { Input } from 'shared-components';

export const AlbumsTable = ({
  albums,
  onCreate,
}: {
  albums: IAlbum[];
  onCreate?: (name: string) => void;
}) => {
  const navigate = useNavigate();
  const [newAlbumName, setNewAlbumName] = useState<string>('');
  return (
    <table>
      <thead>
        <tr>
          <th colSpan={2}>Name</th>
        </tr>
      </thead>
      <tbody>
        {albums.map((a) => (
          <tr
            key={a._id.toString()}
            onClick={() => {
              navigate(`/albums/${a._id}`);
            }}
          >
            <td colSpan={2}>{a.name}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td>
            <Input
              onChange={(e) => {
                setNewAlbumName(e.target.value);
              }}
              type="text"
              placeholder="New album name"
            />
          </td>
          <td>
            <Button
              onClick={async () => {
                onCreate?.(newAlbumName);
              }}
            >
              Create
            </Button>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};
